export default __webpack_public_path__ + "static/media/lif3-logo-simple.1df86d28.svg";